import Alpine from 'alpinejs';
import api, { requireAuth } from './api.js';

async function pollExport(exportId) {
  for (let i = 0; i < 20; i++) {
    const record = await api.exportStatus(exportId);
    if (record.status === 'completed' || record.status === 'failed') return record;
    await new Promise(r => setTimeout(r, 1500));
  }
  return api.exportStatus(exportId);
}

function createInkoCreationExport() {
  return {
    projectId: '',
    loading: true,
    busy: false,
    presets: [],
    formats: ['png'],
    selectedPreset: 'standard_print',
    selectedFormat: 'png',
    exports: [],

    init() {
      this.projectId = this.$el.dataset.projectId || '';
      if (!requireAuth() || !this.projectId) return;
      this.load();
    },

    async load() {
      this.loading = true;
      try {
        const [presetData, list] = await Promise.all([
          api.exportPresets(),
          api.listExports(this.projectId),
        ]);
        this.presets = presetData.presets || [];
        this.formats = presetData.formats || ['png'];
        this.exports = list;
        if (this.presets[0] && !this.presets.find(p => p.key === this.selectedPreset)) {
          this.selectedPreset = this.presets[0].key;
        }
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Gagal memuat export.', 'error');
      } finally {
        this.loading = false;
      }
    },

    async runExport() {
      this.busy = true;
      try {
        let record = await api.exportProject(this.projectId, {
          preset: this.selectedPreset,
          format: this.selectedFormat,
          async: false,
        });
        if (record.status === 'pending' || record.status === 'processing') {
          record = await pollExport(record.export_id);
        }
        if (record.status === 'completed') {
          window.toast?.('Export selesai.', 'success');
          if (record.file_url) window.open(record.file_url, '_blank');
        } else {
          window.toast?.(record.error_message || 'Export gagal.', 'error');
        }
        await this.load();
      } catch (e) {
        window.toast?.(e.response?.data?.message || 'Export gagal.', 'error');
      } finally {
        this.busy = false;
      }
    },
  };
}

Alpine.data('inkoCreationExport', createInkoCreationExport);
